import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import axios from "axios";
import * as Yup from "yup";
import "../index.css";
import { toast } from "react-toastify";
import { APIURLCOT } from "../../../Config";
import demoExcel from "../../../image/Test1.xlsx";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { Modal } from "react-bootstrap";
import ClientDetailCTLoanDetail from "../../ClientDetailCTLoanDetail";

export default function LimitUtilizationCT() {
  const token = localStorage.getItem("token");
  const limitUtilizationTB = React.useRef(null);
  console.log("limitUtilizationTB::: ", limitUtilizationTB);

  const username = "8279848999";
  const password = "5048";
  const emailid = localStorage.getItem("corpadminmail");
  const email = localStorage.getItem("emailId");
  const workspaceid = localStorage.getItem("workspace");
  const [lid, setLid] = useState("");
  const [showSearch, setShowSearch] = useState(false);

  const authString = btoa(`${username}:${password}`);
  const [getlimitExtend, setGetLimitExtend] = useState({});
  const [limitExtend, setLimitExtend] = useState("");
  const [activeTab, setActiveTab] = useState("lu");
  const [showModal, setShowModal] = useState(false);
  const [showModalStatus, setShowModalStatus] = useState(false);

  const [clientList, setClientList] = useState([]);
  const [showUpload, SetShowUpload] = useState(false);
  const fileInputRef = useRef(null);
  const [isLoader, setIsLoader] = useState(false);
  const [newStatus, setNewStatus] = useState("");
  const [newStatus1, setNewStatu1] = useState("1");
  const [mobileNum, setMobileNum] = useState();
  const [totalCount, setTotalCount] = useState({});
  const [width, setWidth] = React.useState(window.innerWidth < 768);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  const limitExtendChange = (e) => {
    setLimitExtend(e.target.value);
  };

  useEffect(() => {
    getClientList();
  }, []);

  const getClientList = () => {
    setClientList([]);

    setNewStatu1(1);
    setIsLoader(true);
    axios
      .request(`${APIURLCOT}/getclientlist`, {
        method: "GET",
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setClientList(response?.data);
        setIsLoader(false);
        const totals = response?.data.reduce(
          (acc, item) => {
            if (item.accountStatus !== "INACTIVE") {
              acc.totalApproved += item.approvedAmount || 0;
              acc.approvedCount += 1;
            }

            if (item.sanctionAmount !== null) {
              acc.totalSanctioned += item.sanctionAmount;
              acc.sanctionCount += 1;
            }

            return acc;
          },
          {
            totalApproved: 0,
            totalSanctioned: 0,
            sanctionCount: 0,
            approvedCount: 0,
          }
        );

        setTotalCount(totals);

        console.log("response::::", response);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };

  const getClientListOpen = () => {
    setClientList([]);

    setNewStatu1(2);
    setIsLoader(true);
    axios
      .request(`${APIURLCOT}/getclientlistSTD`, {
        method: "GET",
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setClientList(response?.data);
        setIsLoader(false);
        const totals = response?.data.reduce(
          (acc, item) => {
            if (item.accountStatus !== "INACTIVE") {
              acc.totalApproved += item.approvedAmount || 0;
              acc.approvedCount += 1;
            }

            if (item.sanctionAmount !== null) {
              acc.totalSanctioned += item.sanctionAmount;
              acc.sanctionCount += 1;
            }

            return acc;
          },
          {
            totalApproved: 0,
            totalSanctioned: 0,
            sanctionCount: 0,
            approvedCount: 0,
          }
        );

        setTotalCount(totals);

        console.log("response::::", response);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };

  const handleSubmit = (limitExtend) => {
    console.log("getlimitExtend::: ", getlimitExtend);
    if (getlimitExtend.limitAssign > limitExtend) {
      toast.warning("Limit must be higher.");
    } else {
      const data = {
        mobile: getlimitExtend.mobileNo,
        limitassigned: limitExtend,
      };
      axios
        .request(`${APIURLCOT}/corporate/updatelimitassigned`, {
          method: "POST",
          data: data,
          headers: {
            Authentication: token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("response", response);
          setShowModal(false);
          getClientList();
          toast.success("Limit extend successfully...");
        })
        .catch((error) => {
          console.log("error", error);
          toast.warning("Invalid...");
        });
    }
  };
  const manageemployeesStatus = (mobile, status) => {
    console.log("mobile::: ", mobile);
    setIsLoader(true);
    axios
      .request(`${APIURLCOT}/employerstatus`, {
        method: "POST",
        data: {
          mobile: mobile,
          status: status,
        },
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        toast.success(response.data);
        getClientList();
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };
  const LoginSchema = Yup.object().shape({
    file: Yup.mixed().required("A file is required"),
  });

  const UploadSchema = Yup.object().shape({
    loanId: Yup.string().required("Requried"),
    name: Yup.string().required("Required"),
    mobile: Yup.string()
      .required("Required")
      .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits"),
    limitassigned: Yup.string().required("Required"),
  });

  // handleSort = (key) => {
  //    const { details, sortConfig } = this.state;
  //    const direction =
  //      sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
  //    const sortedData = [...details].sort((a, b) => {
  //      const valueA = a[key] || 0; // Handle missing or null values
  //      const valueB = b[key] || 0;
  //      if (valueA < valueB) {
  //        return direction === "asc" ? -1 : 1;
  //      }
  //      if (valueA > valueB) {
  //        return direction === "asc" ? 1 : -1;
  //      }
  //      return 0;
  //    });
  //    this.setState({
  //      details: sortedData,
  //      sortConfig: { key, direction },
  //    });
  // };
  const handleDownload = () => {
    setTimeout(() => {
      if (limitUtilizationTB.current) {
        document.getElementById("download-excel-btn").click();
      } else {
        console.log("Table ref is null, delaying...");
      }
    }, 500);
  };
  return (
    <div className={width ? "container" : "p-3"}>
      <div>
        <ul className="nav nav-tabs-CT" id="myTabs" role="tablist">
          <li
            className={width ? "nav-item mt-2" : "nav-item"}
            role="presentation"
          >
            <button
              className={`nav-link nav-itm-CT tab-item ${
                activeTab === "lu" ? "active" : ""
              }`}
              id="lu-tab"
              type="button"
              role="tab"
              aria-controls="limitutilization"
              aria-selected={activeTab === "lu"}
              onClick={() => {
                handleTabClick("lu");
                getClientList();
              }}
            >
              Limit Utilization
            </button>
          </li>
          <li
            className={width ? "nav-item mt-2" : "nav-item"}
            role="presentation"
          >
            <button
              className={`nav-link nav-itm-CT tab-item ${
                activeTab === "upload" ? "active" : ""
              }`}
              id="upload-tab"
              type="button"
              role="tab"
              aria-controls="upload"
              aria-selected={activeTab === "upload"}
              onClick={() => handleTabClick("upload")}
            >
              Upload Limit
            </button>
          </li>
        </ul>

        <div className="tab-content mt-3" id="myTabsContent">
          <div
            className={`tab-pane fade ${
              activeTab === "upload" ? "show active" : ""
            }`}
            id="upload"
            role="tabpanel"
            aria-labelledby="upload-tab"
          >
            <div className="pt-3">
              <div className="card">
                <div className="p-4">
                  <div className="justify-content-end  ml-auto">
                    {!showUpload ? (
                      <button
                        className="btn  "
                        style={{
                          width: "120px",
                          backgroundColor: "black",
                          color: "white",
                        }}
                        onClick={() => SetShowUpload(true)}
                      >
                        Add
                      </button>
                    ) : (
                      <button
                        className="mr-3 btn btn-secondary"
                        style={{ width: "120px" }}
                        onClick={() => SetShowUpload(false)}
                      >
                        Back
                      </button>
                    )}
                  </div>

                  {!showUpload ? (
                    <Formik
                      initialValues={{
                        file: null,
                      }}
                      validationSchema={LoginSchema}
                      onSubmit={(values, { resetForm }) => {
                        const formData = new FormData();
                        formData.append("file", values.file);
                        // formData.append("emailid", email);
                        // formData.append("ownerEmail", emailid);
                        // formData.append("workspaceId", workspaceid);
                        for (let pair of formData.entries()) {
                          console.log(pair[0], pair[1]);
                        }
                        setIsLoader(true);
                        axios
                          .request(`${APIURLCOT}/upload`, {
                            method: "POST",
                            data: formData,
                            headers: {
                              Authentication: token,

                              Authentication: `Basic ${authString}`,
                            },
                          })
                          .then((response) => {
                            console.log("response::", response);
                            setIsLoader(false);
                            toast.success(response?.data);
                            resetForm();
                            fileInputRef.current.value = null;
                          })
                          .catch((error) => {
                            console.log("error", error);
                            setIsLoader(false);
                            toast.warning("Invalid...");
                            fileInputRef.current.value = null;
                            resetForm();
                          });
                      }}
                    >
                      {({ touched, errors, setFieldValue }) => (
                        <>
                          <Form className="pt-4">
                            <div
                              className="row"
                              style={{ alignItems: "center" }}
                            >
                              <div className="col-lg-9 col-md-9 col-sm-12">
                                <div className="form-group">
                                  <label htmlFor="file">Upload File</label>
                                  <input
                                    id="file"
                                    name="file"
                                    type="file"
                                    accept=".xlsx, .xls"
                                    ref={fileInputRef}
                                    className={`form-control ${
                                      touched.file && errors.file
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    onChange={(event) => {
                                      const file = event.currentTarget.files[0];
                                      setFieldValue("file", file);
                                    }}
                                  />
                                  <ErrorMessage
                                    name="file"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3 col-md-3 col-sm-12  d-flex justify-content-center">
                                <a
                                  download="Demo.xlsx"
                                  href={demoExcel}
                                  style={{
                                    width: "200px",
                                    backgroundColor: "#6c757d",
                                  }}
                                  className="btn btn-secondary mt-3 ml-auto"
                                >
                                  Download Demo File
                                </a>
                              </div>
                            </div>

                            <button
                              type="submit"
                              className="btn btn-success mt-3"
                              style={{
                                backgroundColor: "black",
                                color: "white",
                              }}
                            >
                              {isLoader ? (
                                <div
                                  className="spinner-border text-success"
                                  role="status"
                                >
                                  <span className="sr-only">Loading...</span>
                                </div>
                              ) : (
                                "Submit"
                              )}
                            </button>
                            {isLoader && (
                              <div className="text-center mt-3">
                                <p>
                                  Please be patient we are simultaneously
                                  updating employee limits
                                </p>
                              </div>
                            )}
                          </Form>
                        </>
                      )}
                    </Formik>
                  ) : (
                    <Formik
                      initialValues={{
                        name: "",
                        mobile: "",
                        limitassigned: "",
                      }}
                      validationSchema={UploadSchema}
                      onSubmit={(values, { resetForm }) => {
                        if (
                          !values.name ||
                          !values.mobile ||
                          !values.limitassigned
                        ) {
                          toast.warning("All field required...");
                        } else {
                          const data = {
                            loanId: values.loanId,
                            emailid: email,
                            name: values.name,
                            mobile: values.mobile,
                            limitassigned: values.limitassigned,
                            workspaceId: workspaceid,
                            ownerEmail: email,
                          };
                          setIsLoader(true);
                          axios
                            .request(`${APIURLCOT}/addemployee`, {
                              method: "POST",
                              data: data,
                              headers: {
                                Authentication: token,
                              },
                            })
                            .then((response) => {
                              setIsLoader(false);
                              SetShowUpload(false);
                              toast.success(response?.data);
                              resetForm();
                            })
                            .catch((error) => {
                              console.log("error", error);
                              setIsLoader(false);
                              SetShowUpload(false);
                              toast.warning("Invalid...");
                              resetForm();
                            });
                        }
                      }}
                    >
                      {({ touched, errors }) => (
                        <Form className="pt-4">
                          <div>
                            <label className="ml-1">CTL Loan ID*</label>
                            <Field
                              type="number"
                              name="loanId"
                              placeholder="Enter LoanID"
                              onWheel={(e) => e.target.blur()}
                              className={`form-control ${
                                touched.loanId && errors.loanId
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="loanId"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="mt-2">
                            <label className="ml-1">Client Name*</label>
                            <Field
                              type="text"
                              name="name"
                              placeholder="Enter name"
                              className={`form-control ${
                                touched.name && errors.name ? "is-invalid" : ""
                              }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="name"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="mt-2">
                            <label className="ml-1">Client Mobile*</label>
                            <Field
                              type="number"
                              name="mobile"
                              placeholder="Enter mobile"
                              onWheel={(e) => e.target.blur()}
                              className={`form-control ${
                                touched.mobile && errors.mobile
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="mobile"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="mt-2">
                            <label className="ml-1">Limit Assigned*</label>
                            <Field
                              type="number"
                              name="limitassigned"
                              onWheel={(e) => e.target.blur()}
                              placeholder="Enter limit assigned"
                              className={`form-control ${
                                touched.limitassigned && errors.limitassigned
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="limitassigned"
                              className="invalid-feedback"
                            />
                          </div>
                          <button
                            type="submit"
                            className="btn btn-success mt-3"
                            style={{ backgroundColor: "black", color: "white" }}
                          >
                            {isLoader ? (
                              <div
                                className="spinner-border text-success"
                                role="status"
                              >
                                <span className="sr-only">Loading...</span>
                              </div>
                            ) : (
                              "Submit"
                            )}
                          </button>
                        </Form>
                      )}
                    </Formik>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div
            className={`tab-pane fade ${
              activeTab === "lu" ? "show active" : ""
            }`}
            id="limitutilization"
            role="tabpanel"
            aria-labelledby="lu-tab"
          >
            {console.log("showSearch::: ", showSearch)}
            {showSearch && (
              <>
                <div className="p-3 d-flex justify-content-start mt-3">
                  <button
                    className="btn btn-secondary"
                    style={{ width: "100px" }}
                    onClick={() => {
                      setShowSearch(false);
                    }}
                  >
                    Back
                  </button>
                </div>
                <div className="p-3 pt-2">
                  <ClientDetailCTLoanDetail lid={lid} />
                </div>
              </>
            )}
            {!showSearch && (
              <div className="pt-3">
                <div className="card">
                  <div className="p-3 pt-4">
                    <div className="d-flex">
                      <button
                        className={
                          newStatus1 == 1
                            ? "btn btn-primary"
                            : "btn btn-outline-primary ml-2"
                        }
                        style={{ width: "130px" }}
                        onClick={() => getClientList()}
                      >
                        CPC
                      </button>
                      <button
                        className={
                          newStatus1 == 2
                            ? "btn btn-primary ml-2"
                            : "btn btn-outline-primary ml-2"
                        }
                        style={{ width: "130px" }}
                        onClick={() => getClientListOpen()}
                      >
                        Open Market
                      </button>
                    </div>
                    <div className="d-flex mt-3 flex-wrap">
                      <DownloadTableExcel
                        filename="LeadsCT"
                        sheet="users"
                        currentTableRef={limitUtilizationTB.current}
                      >
                        <button
                          className="btn btn-success border"
                          style={{
                            width: "120px",
                            backgroundColor: "black",
                          }}
                        >
                          {" "}
                          Download{" "}
                        </button>
                      </DownloadTableExcel>
                      <div className="ml-auto mr-3">
                        <div className="d-flex justify-content-center gap-3">
                          <div className="flex items-center gap-1">
                            <b>Limit Assigned Count:-</b>
                            <span className="ml-1">
                              {totalCount?.approvedCount || 0}
                            </span>
                            <div>
                              <div className="flex items-center mt-2">
                                <b>Limit Used Count:-</b>
                                <span className="ml-1">
                                  {totalCount?.sanctionCount || 0}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="flex items-center gap-1">
                            <b>Limit Assigned:-</b>
                            <span className="ml-1">
                              {totalCount?.totalApproved || 0}
                            </span>
                            <div className="flex items-center mt-2">
                              <b>Limit Used:- </b>
                              <span className="ml-1">
                                {totalCount?.totalSanctioned || 0}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {isLoader ? (
                      <div className="d-flex justify-content-center">
                        <div
                          className="spinner-border text-success"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <table
                          className="table table-striped mt-3"
                          ref={limitUtilizationTB}
                        >
                          <thead>
                            <tr>
                              <th style={{ textAlign: "center" }}>Sr. No</th>
                              <th style={{ textAlign: "center" }}>
                                Date Approved
                              </th>
                              <th style={{ textAlign: "center" }}>Loan Id</th>
                              <th style={{ textAlign: "center" }}>
                                Client Name
                              </th>
                              {/* <th style={{ textAlign: "center" }}>
                                Customer Type
                              </th> */}
                              <th style={{ textAlign: "center" }}>
                                Mobile No.
                              </th>
                              <th style={{ textAlign: "center" }}>
                                Branch Name
                              </th>
                              <th style={{ textAlign: "center" }}>
                                Limit Assigned
                              </th>
                              <th
                                style={{ textAlign: "center" }}
                                // onClick={() => this.handleSort("thirtycase")} // Pass the key dynamically
                              >
                                <span
                                  style={{
                                    display: "inline-flex", // Ensures that the content behaves like a flexbox
                                    justifyContent: "center", // Centers the content horizontally
                                    alignItems: "center", // Centers the content vertically
                                    gap: "8px",
                                    width: "100%", // Takes full width of the parent
                                  }}
                                >
                                  Limit Used
                                  {/* {this.state.sortConfig.key === "thirtycase" ? (
                          this.state.sortConfig.direction === "asc" ? (
                            <span>▲</span>
                          ) : (
                            <span>▼</span>
                          )
                        ) : (
                          <span>↕</span>
                        )} */}
                                </span>
                              </th>
                              <th
                                style={{ width: "150px", textAlign: "center" }}
                                onClick={() => this.handleSort("thirtycase")} // Pass the key dynamically
                              >
                                <span
                                  style={{
                                    display: "inline-flex", // Ensures that the content behaves like a flexbox
                                    justifyContent: "center", // Centers the content horizontally
                                    alignItems: "center", // Centers the content vertically
                                    gap: "8px",
                                    width: "100%", // Takes full width of the parent
                                  }}
                                >
                                  Change Limit
                                  {/* {this.state.sortConfig.key === "thirtycase" ? (
                          this.state.sortConfig.direction === "asc" ? (
                            <span>▲</span>
                          ) : (
                            <span>▼</span>
                          )
                        ) : (
                          <span>↕</span>
                        )} */}
                                </span>
                              </th>

                              <th style={{ textAlign: "center" }}>Status</th>
                              <th style={{ textAlign: "center" }}>
                                Change Status
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {clientList && clientList.length > 0 ? (
                              clientList.map((detail, index) => (
                                <tr key={index}>
                                  <td style={{ textAlign: "center" }}>
                                    {index + 1}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {detail.approvedDate
                                      ? new Date(
                                          detail.approvedDate
                                        ).toLocaleDateString("en-GB", {
                                          day: "2-digit",
                                          month: "2-digit",
                                          year: "numeric",
                                        })
                                      : "-"}
                                  </td>
                                  <td
                                    style={{
                                      color: "blue",
                                      cursor: "pointer",
                                      textAlign: "center",
                                    }}
                                    onClick={() => {
                                      if (detail.loanId) {
                                        setLid(detail.loanId);
                                        setShowSearch(true);
                                      }
                                    }}
                                  >
                                    {detail.loanId || 0}
                                  </td>
                                  <td style={{ textAlign: "left" }}>
                                    {detail.customerName}
                                  </td>
                                  {/* <td style={{ textAlign: "center" }}>
                                    {detail.customerType}
                                  </td> */}
                                  <td style={{ textAlign: "center" }}>
                                    {detail.mobileNo}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {detail.branchName || "-"}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {detail.approvedAmount}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {detail.sanctionAmount || 0}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <button
                                      className="btn btn-info"
                                      style={{ width: "100px" }}
                                      onClick={() => {
                                        setShowModal(true);
                                        setLimitExtend(detail.approvedAmount);
                                        setGetLimitExtend(detail);
                                      }}
                                    >
                                      Extend
                                    </button>
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <div className="d-flex justify-content-center">
                                      {detail?.accountStatus === "ACTIVE" ? (
                                        <button className="btn btn-success">
                                          Active
                                        </button>
                                      ) : detail?.accountStatus ===
                                        "INACTIVE" ? (
                                        <button className="btn btn-danger">
                                          Inactive
                                        </button>
                                      ) : (
                                        <button className="btn btn-warning">
                                          Unknown
                                        </button>
                                      )}
                                    </div>
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <button
                                      className="btn btn-secondary"
                                      style={{ width: "100px" }}
                                      onClick={() => {
                                        setNewStatus(
                                          detail?.accountStatus === "ACTIVE"
                                            ? "INACTIVE"
                                            : "ACTIVE"
                                        );
                                        setMobileNum(detail?.mobileNo);
                                        setShowModalStatus(true);
                                      }}
                                    >
                                      Change
                                    </button>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan="11"
                                  style={{ textAlign: "center" }}
                                >
                                  No data available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        <Modal
                          show={showModalStatus}
                          onHide={() => setShowModalStatus(false)}
                          style={{ background: "rgb(255 255 255 / 40%)" }}
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>Change Status</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <p>
                              Are you sure you want to change status to{" "}
                              <strong>{newStatus}</strong>?
                            </p>
                            <div className="d-flex mt-3 justify-content-end">
                              <button
                                className="btn btn-secondary"
                                style={{ width: "100px" }}
                                onClick={() => setShowModalStatus(false)}
                              >
                                Cancel
                              </button>
                              <button
                                className="btn btn-success ml-2"
                                style={{
                                  width: "100px",
                                  background: "#66a725",
                                }}
                                onClick={() => {
                                  manageemployeesStatus(mobileNum, newStatus);
                                  setShowModalStatus(false);
                                }}
                              >
                                Confirm
                              </button>
                            </div>
                          </Modal.Body>
                        </Modal>
                        <Modal
                          show={showModal}
                          onHide={() => setShowModal(false)}
                          style={{ background: "rgb(255 255 255 / 40%)" }}
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>Limit Extend</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <input
                              type="number"
                              value={limitExtend}
                              onChange={limitExtendChange}
                              style={{
                                width: "100%",
                                padding: "10px",
                                boxSizing: "border-box",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                marginTop: "10px",
                                fontSize: "18px",
                              }}
                            />
                            <div className="d-flex mt-3 justify-content-end">
                              <button
                                className="btn btn-secondary"
                                style={{ width: "100px" }}
                                onClick={() => setShowModal(false)}
                              >
                                Cancel
                              </button>
                              <button
                                className="btn btn-success ml-2"
                                style={{
                                  width: "100px",
                                  background: "#66a725",
                                }}
                                onClick={() => handleSubmit(limitExtend)}
                              >
                                Submit
                              </button>
                            </div>
                          </Modal.Body>
                        </Modal>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
